import axios, { AxiosInstance } from 'axios';

const authClient: AxiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_BASE_URL_API}/api/v1`,
  withCredentials: true,
});

export const authService = {
  async logout() {
    await authClient.post('/auth/logout');
  },
};
